import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'modals.buildProgress.header.title' }),
    titleWithRange: (range: string) =>
      translate({ id: 'modals.buildProgress.header.titleWithRange', values: { range } }),

    // Step 1 — matrix creation
    step1Title: translate({ id: 'modals.buildProgress.step1.title' }),
    step1Description: translate({ id: 'modals.buildProgress.step1.description' }),

    step1LinearIntro: [
      translate({ id: 'modals.buildProgress.step1.linear.wakingUp' }),
      translate({ id: 'modals.buildProgress.step1.linear.gathering' }),
      translate({ id: 'modals.buildProgress.step1.linear.syncing' }),
      translate({ id: 'modals.buildProgress.step1.linear.calibrating' }),
    ],

    step1PreparationLoop: [
      translate({ id: 'modals.buildProgress.step1.loop.organizing' }),
      translate({ id: 'modals.buildProgress.step1.loop.structuring' }),
      translate({ id: 'modals.buildProgress.step1.loop.indexing' }),
      translate({ id: 'modals.buildProgress.step1.loop.preparing' }),
    ],
    step1PreparationFinalizing: translate({ id: 'modals.buildProgress.step1.loop.finalizing' }),

    // Step 2 — optimization

    step2Rotation: [
      translate({ id: 'modals.buildProgress.step2.testing' }),
      translate({ id: 'modals.buildProgress.step2.applyingRules' }),
      translate({ id: 'modals.buildProgress.step2.refining' }),
      translate({ id: 'modals.buildProgress.step2.balancing' }),
      translate({ id: 'modals.buildProgress.step2.evaluating' }),
      translate({ id: 'modals.buildProgress.step2.running' }),
      translate({ id: 'modals.buildProgress.step2.polishing' }),
      translate({ id: 'modals.buildProgress.step2.checking' }),
    ],
    step2WrappingUp: translate({ id: 'modals.buildProgress.step2.wrappingUp' }),

    // Optimization configuration panel
    optimizationConfiguration: translate({
      id: 'modals.buildProgress.optimizationConfiguration',
    }),

    // Discard
    discardOptimization: translate({ id: 'modals.buildProgress.discard.button' }),
    discardConfirmTitle: translate({ id: 'modals.buildProgress.discard.confirm.title' }),
    discardConfirmBody: translate({ id: 'modals.buildProgress.discard.confirm.body' }),
    discardConfirmKeep: translate({ id: 'modals.buildProgress.discard.confirm.keep' }),
    discardConfirmConfirm: translate({ id: 'modals.buildProgress.discard.confirm.confirm' }),

    // Complete screen
    completeTitle: translate({ id: 'modals.buildProgress.complete.title' }),
    completeSubtitle: translate({ id: 'modals.buildProgress.complete.subtitle' }),
    completeViewRoutes: translate({ id: 'modals.buildProgress.complete.viewRoutes' }),

    completeStatUnassigned: translate({ id: 'modals.buildProgress.complete.stat.unassigned' }),
    completeStatOrders: translate({ id: 'modals.buildProgress.complete.stat.orders' }),
    completeStatVehicles: translate({ id: 'modals.buildProgress.complete.stat.vehicles' }),
    completeStatCost: translate({ id: 'modals.buildProgress.complete.stat.cost' }),
    completeStatDistance: translate({ id: 'modals.buildProgress.complete.stat.distance' }),
    completeStatWorkingTime: translate({ id: 'modals.buildProgress.complete.stat.workingTime' }),

    completeStatTotalUnassigned: translate({
      id: 'modals.buildProgress.complete.stat.totalUnassigned',
    }),
    completeStatTotalOrders: translate({
      id: 'modals.buildProgress.complete.stat.totalOrders',
    }),
    completeStatTotalVehicles: translate({
      id: 'modals.buildProgress.complete.stat.totalVehicles',
    }),
    completeStatTotalCost: translate({ id: 'modals.buildProgress.complete.stat.totalCost' }),
    completeStatTotalDistance: translate({
      id: 'modals.buildProgress.complete.stat.totalDistance',
    }),
    completeStatTotalWorkingTime: translate({
      id: 'modals.buildProgress.complete.stat.totalWorkingTime',
    }),

    // Legacy keys (kept for build to not break old usages until removed)
    buildingYourRoutes: translate({ id: 'loader.buildingYourRoutes' }),
    optimizationInProgress: translate({ id: 'loader.optimizationInProgress' }),
    cancelOptimization: translate({ id: 'loader.cancelOptimization' }),
  }))

  return api
}
